import { isRejectedWithValue } from '@reduxjs/toolkit';

import { getSupportEmail } from 'config';
import { danger } from '@valid-eval/shared-react-components';
import { useTranslation } from 'react-i18next';

/**
 * React hook that returns a function to check if a result is rejected (using isRejectedWithValue),
 * shows an error message to the user if so, and returns a tuple of [result, boolean].
 *
 * The boolean flag is true if the result was rejected and an error was shown, false otherwise.
 *
 * @returns {(result: any) => [any, boolean]} Function that takes a result, shows an error if rejected, and returns [result, isError]
 */
export const useShowErrorIfRejected = () => {
  const { t } = useTranslation();

  return (result: any): [any, boolean] => {
    if (isRejectedWithValue(result)) {
      const payload: any = result.payload;

      const message =
        payload?.response?.error || t('frontend.common.generic_error', getSupportEmail());
      danger(message);
      return [result, true];
    }
    return [result, false];
  };
};
